import { render, staticRenderFns } from "./Kratodo.vue?vue&type=template&id=115939f2&"
import script from "./Kratodo.vue?vue&type=script&lang=js&"
export * from "./Kratodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports